import { TicketCode } from "./ticket";

export class ServiceAreaCodes {
    ticketCode: TicketCode[];
}

export class CodeDiffDisplay {
    code: string;
    organizationName: string;
    isAdded: boolean;
    isSuppressed; boolean;
    isSystemSuppressed: boolean;
    organizationFacilities: string;
    diff: number;
}

export class NewWorkArea {
    geom: string;
    codes: TicketCode[];
}


export class CallerSuppliedGeometry {
    Number: string;
    GeometryWkt: string;
    SubmittedBy: string;
}

export class MapPolygon {
    // name: string;
    // wkt: string;
    // polygon: google.maps.Polygon;
  
    // constructor(public _name: string, public _wkt: string, public _polygon: google.maps.Polygon) {
    constructor(public name: string, public wkt: string, public polygon: google.maps.Polygon) {
    }
  }